import React from "react"
import numeral from "numeral"
import settings from "settings"

// This file is all the quick stats with the border around them

function buildMonthlyBox(value) {
	return (
		<div className="absolute bottom-0 left-0 w-full bg-white text-blue text-xs text-center quickStats__whiteBox" title="Monthly average since inception"><span>Monthly Avg: {value}</span></div>
	)
}

export function QuickGrossSales(props) {
	let i = 0
	_.forEach(props.payload.sales.current, (v) => {
		if (v.transfer_date) {
			return
		}
		i++
	})
	let average
	if(settings?.enabled?.quickMonthlyAverages) {
		average = buildMonthlyBox(props.payload?.exec?.monthlyAverages?.gross)
	}
	return (
		<div className="static">
			<div className="quickStats__stat">{numeral(i).format("0,0")}</div>
			<div className="quickStats__type"><span>Gross Sales</span></div>
			{average}
		</div>
	)
}

export function QuickCancels(props) {
	let i = 0
	_.forEach(props.payload.bustouts.current, (v) => {
		if (v.transfer_date) {
			return
		}
		i++
	})
	let average
	if (settings?.enabled?.quickMonthlyAverages) {
		average = buildMonthlyBox(props.payload?.exec?.monthlyAverages?.cancels)
	}
	return (
		<div className="static">
			<div className="quickStats__stat">{numeral(i).format("0,0")}</div>
			<div className="quickStats__type"><span>Cancels</span></div>
			{average}
		</div>
	)
}

export function QuickNet(props) {
	let i = 0
	_.forEach(props.payload.sales.current, (v) => {
		if (v.transfer_date) {
			return
		}
		i++
	})
	_.forEach(props.payload.bustouts.current, (v) => {
		if (v.transfer_date) {
			return
		}
		i--
	})
	let average
	if (settings?.enabled?.quickMonthlyAverages) {
		average = buildMonthlyBox(props.payload?.exec?.monthlyAverages?.net)
	}
	return (
		<div className="static">
			<div className="quickStats__stat">{numeral(i).format("0,0")}</div>
			<div className="quickStats__type"><span>Net Sales</span></div>
			{average}
		</div>
	)
}

export function QuickTransfers(props) {
	let average
	if (settings?.enabled?.quickMonthlyAverages) {
		average = buildMonthlyBox(props.payload?.exec?.monthlyAverages?.transfers)
	}
	return (
		<div className="static">
			<div className="quickStats__stat">{props.payload.transfers.current.length.toLocaleString()}</div>
			<div className="quickStats__type"><span>Transfers</span></div>
			{average}
		</div>
	)
}

export function QuickClosings(props) {
	let average
	if (settings?.enabled?.quickMonthlyAverages) {
		average = buildMonthlyBox(props.payload?.exec?.monthlyAverages?.closings)
	}
	return (
		<div className="static">
			<div className="quickStats__stat">{props.payload.closings.current.length.toLocaleString()}</div>
			<div className="quickStats__type"><span>Closings</span></div>
			{average}
		</div>
	)
}

export function QuickStarts(props) {
	let i = 0
	_.forEach(props.payload.exec.lots, (v) => {
		if (v.start_date >= props.currentDates.startStamp && v.start_date <= props.currentDates.endStamp) {
			i++
		}
	})
	let average
	if (settings?.enabled?.quickMonthlyAverages) {
		average = buildMonthlyBox(props.payload?.exec?.monthlyAverages?.starts)
	}
	return (
		<div className="static">
			<div className="quickStats__stat">{i}</div>
			<div className="quickStats__type"><span>Starts</span></div>
			{average}
		</div>
	)
}

export function QuickCompletes(props) {
	let i = 0
	_.forEach(props.payload.exec.lots, (v) => {
		if (v.complete_date >= props.currentDates.startStamp && v.complete_date <= props.currentDates.endStamp) {
			i++
		}
	})
	let average
	if (settings?.enabled?.quickMonthlyAverages) {
		average = buildMonthlyBox(props.payload?.exec?.monthlyAverages?.completes)
	}
	return (
		<div className="static">
			<div className="quickStats__stat">{i}</div>
			<div className="quickStats__type"><span>Completes</span></div>
			{average}
		</div>
	)
}

export function QuickTraffic(props) {
	let i = props.payload.exec.traffic.grouped_total
	let indiv = props.payload.exec.traffic.individual
	if(indiv && indiv.length > 0) i += indiv.length
	let average
	if (settings?.enabled?.quickMonthlyAverages) {
		average = buildMonthlyBox(props.payload?.exec?.monthlyAverages?.traffic)
	}
	return (
		<div className="static">
			<div className="quickStats__stat">{numeral(i).format("0,0")}</div>
			<div className="quickStats__type">Traffic Entries</div>
			{average}
		</div>
	)
}

export function QuickBuilderTraffic(props) {
	let count = 0
	_.forEach(props.payload.traffic.current.grouped.array, (v) => {
		if(v.welcomeCenter) return
		count += v.prospect_count + v.realtor_count
	})
	_.forEach(props.payload.traffic.current.entries, (v) => {
		if(v.welcomeCenter) return
		count++
	})
	return (
		<div className="static">
			<div className="quickStats__stat">{numeral(count).format("0,0")}</div>
			<div className="quickStats__type"><span>Builder Traffic</span></div>
		</div>
	)
}

export function QuickWelcomeTraffic(props) {
	let count = 0
	_.forEach(props.payload.traffic.current.grouped.array, (v) => {
		if (!v.welcomeCenter) return
		count += v.prospect_count + v.realtor_count
	})
	_.forEach(props.payload.traffic.current.entries, (v) => {
		if (!v.welcomeCenter) return
		count++
	})
	return (
		<div className="static">
			<div className="quickStats__stat">{numeral(count).format("0,0")}</div>
			<div className="quickStats__type"><span>Welcome Center Traffic</span></div>
		</div>
	)
}
